import { UnicornVariantIcon } from './UnicornVariantIcon';

/**
 * author: Colton Wiscombe
 * id D0825387-637B-4EB5-BCF5-470A7FCE1F05
 * name unicorn-variant
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unicorn-variant.svg
 * tags
 * - Animal 
 */
export const FantasyVariantIcon = UnicornVariantIcon;
export default FantasyVariantIcon